import React, { useEffect, useState } from "react";
import Logo from "../assets/logo-full-white.png"; // Adjust the path as necessary
import ImgOptimized from "./ImgOptimized";

const Intro = () => {
  const [logoScale, setLogoScale] = useState(30);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLogoScale(100);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  // Arrays of Unsplash images for different office/interior themes
  const officeImages = [
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/433865.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/429106.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/430319.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/431419.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/433858.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/430298.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/433844.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/431405.jpg?size=small",
  ];

  const interiorImages = [
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/433843.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/431445.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/429111.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/433849.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/429103.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/433857.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/429109.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/430314.jpg?size=small",
  ];

  const modernImages = [
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/433842.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/431434.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/433841.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/431428.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/430305.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/433839.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/429084.jpg?size=small",
    "https://design-api.airbrickinfra.com/api/minio/static/brick-img/429090.jpg?size=small",
  ];

  return (
    <div className={`relative w-full h-screen overflow-hidden bg-gray-200 `}>
      {/* First Row - Left to Right */}
      <div className="absolute top-0 left-0 w-full h-1/3 flex animate-scroll-left p-2">
        {officeImages.concat(officeImages).map((img, index) => (
          <div
            key={`row1-${index}`}
            className="flex-shrink-0 w-80 h-full rounded-lg mx-2 overflow-hidden"
          >
            <ImgOptimized
              src={img}
              alt={`Office ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>

      {/* Second Row - Right to Left */}
      <div className="absolute top-1/3 left-0 w-full h-1/3 flex animate-scroll-right p-2">
        {interiorImages.concat(interiorImages).map((img, index) => (
          <div
            key={`row2-${index}`}
            className="flex-shrink-0 w-80 h-full rounded-lg mx-2 overflow-hidden"
          >
            <ImgOptimized
              src={img}
              alt={`Interior ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>

      {/* Third Row - Left to Right */}
      <div className="absolute top-2/3 left-0 w-full h-1/3 flex animate-scroll-left p-2">
        {modernImages.concat(modernImages).map((img, index) => (
          <div
            key={`row3-${index}`}
            className="flex-shrink-0 w-80 h-full rounded-lg mx-2 overflow-hidden"
          >
            <ImgOptimized
              src={img}
              alt={`Modern ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40" />

      {/* Logo and Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center z-10">
        {/* Logo */}
        <div
          className="transition-transform duration-1000 ease-out mb-8"
          style={{
            transform: `scale(${logoScale / 100})`,
          }}
        >
          <div className="w-36 h-36 bg-teal-500 rounded-full flex items-center justify-center">
            {/* <span className="text-white text-2xl font-bold">AirBrick™</span> */}
            <ImgOptimized src={Logo} alt="AirBrick Logo" className="w-32  " />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-white text-6xl font-bold mb-4 text-center">
          Welcome to AirBrick
        </h1>

        {/* Subtitle */}
        <p className="text-white text-xl opacity-90 text-center">
          Discover stunning interiors tailored to your style.
        </p>
      </div>

      <style jsx>{`
        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        @keyframes scroll-right {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }

        .animate-scroll-left {
          animation: scroll-left 20s linear infinite;
        }

        .animate-scroll-right {
          animation: scroll-right 20s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Intro;
